import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import Logger from '~/web-frontend-core/devtools/logger';
import { SITE_TYPE } from '~/web-frontend-core/api/const/base';
import { ResultsLiveMenuListener } from '~/web-frontend-core/api/connector/results/live/Menu';
export const ALL_SPORTS_ID = 'all';
const allSportsItem = { hasMatches: true, id: ALL_SPORTS_ID, name: 'ALL' };
export const OTHER_SPORTS_ID = 'other';
const otherSportsItem = { hasMatches: true, id: OTHER_SPORTS_ID, name: 'OTHER' };
/** Т.к результаты singleton, используем константный ID */
const subscriptionID = 0;
export class ResultsMenu extends Subscribtion {
    constructor({ siteType, lng }) {
        super();
        this.selected = new Set();
        this.data = {
            hasMatches: false,
            topSports: [],
            otherSportsHasMatches: false
        };
        this.update = this.update.bind(this);
        this.select = this.select.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.wsListener = new ResultsLiveMenuListener({
            site: siteType || SITE_TYPE.COM,
            lng,
        });
    }
    getData() {
        if (!this.data.hasMatches) {
            return null;
        }
        return this.data;
    }
    getSelected() {
        return Array.from(this.selected.values());
    }
    clear() {
        this.data = {
            hasMatches: false,
            topSports: [],
            otherSportsHasMatches: false
        };
        this.selected.clear();
    }
    select(sportID, isSelected) {
        if (sportID === ALL_SPORTS_ID) {
            this.selected = new Set(isSelected ? [ALL_SPORTS_ID] : []);
            this.notify();
            return;
        }
        this.selected.delete(ALL_SPORTS_ID);
        isSelected ? this.selected.add(sportID) : this.selected.delete(sportID);
        this.notify();
    }
    isSelected(sportID) {
        return this.selected.has(sportID);
    }
    //#region WS
    /**
    * Подписка на обновления таблицы live доп.исходов через WS
    */
    listenWS({ callback, errback } = {}) {
        const logger = Logger.getInstance();
        const onerror = (e) => {
            logger.error(e);
            this.stopListenWS();
            errback && errback(e);
        };
        const onopen = () => {
            // logger.log('[ResultsMenu] Соединение открыто');
            callback && callback();
        };
        const onmessage = this.update;
        this.wsListener.subscribe({
            subscriptionID,
            onmessage,
            onerror,
            onopen,
        });
    }
    update(data) {
        this.data.hasMatches = data.hasMatches;
        this.data.otherSportsHasMatches = data.otherSportsHasMatches;
        this.data.topSports = [allSportsItem]
            .concat(data.topSports)
            .concat(data.otherSportsHasMatches ? [otherSportsItem] : []);
        this.notify();
    }
    stopListenWS() {
        // this.wsListener.unsubscribe({ subscriptionID });
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/results/live/Menu.js